import { VariationJsEnv } from "../variation_js_env";


// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setRrRequestParams = (R3_COMMON: r3_common, pageOption: any, isSoloare?: boolean) => {
  const R3_ITEM = new r3_item();
  if (isSoloare) {
    R3_COMMON.addPlacementType('item_page');
  } else {
    R3_COMMON.addPlacementType(`item_page.${pageOption.placementNameVariationsUpper}`);
    R3_COMMON.addPlacementType(`item_page.${pageOption.placementNameVariationsLower}`);
  }
  R3_COMMON.addCategoryHintId(pageOption.sCategoryCode);

  R3_ITEM.setId(pageOption.topItemCode);
  R3_ITEM.setName(pageOption.topItemName);
};

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setAddToCartPageRrRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
  const R3_ITEM = new r3_item();
  R3_COMMON.addPlacementType(
    `add_to_cart_page.${pageOption.placementNameVariationsMyCatalogModal}`
  );
  R3_COMMON.addCategoryHintId(pageOption.sCategoryCode);

  R3_ITEM.setId(pageOption.topItemCode);
  R3_ITEM.setName(pageOption.topItemName);
};

export const createRrRequestParam = (model: VariationJsEnv) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setRrRequestParams,
    pageOption: {
      placementNameVariationsUpper: model.rrAreaProfileVariationsUpper.placementName,
      placementNameVariationsLower: model.rrAreaProfileVariationsLower.placementName,
      sCategoryCode: model.sCategoryCode,
      topItemCode: model.topItemCode,
      topItemName: model.topItemName
    }
  };
};

export const setRrItemModalRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
  const R3_ADDTOCART = new r3_addtocart();
  R3_COMMON.addPlacementType(`add_to_cart_page.${pageOption.placementNameItemModal}`);
  R3_ADDTOCART.addItemIdToCart(pageOption.catalogItemCode);
};

export const createRrItemModalRequestParam = (model: VariationJsEnv, catalogItemCode: string) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setRrItemModalRequestParams,
    pageOption: {
      placementNameItemModal: model.rrAreaProfileItemModal.placementName,
      catalogItemCode: catalogItemCode
    },
  };
};
